package dev.danko.roblox_craft_ai.shared.repository

import dev.danko.roblox_craft_ai.shared.model.AssetResponse

interface AssetCacheRepository {
    suspend fun getRecent(sessionTokenHash12: String, limit: Int = 50): List<AssetResponse>
    suspend fun upsert(sessionTokenHash12: String, asset: AssetResponse)
    suspend fun delete(sessionTokenHash12: String, assetId: String)
    suspend fun clearAll(sessionTokenHash12: String)
    suspend fun purgeOld(maxAgeMs: Long = 7L * 24 * 60 * 60 * 1000, maxTotalPerToken: Int = 50)
}

data class CachedAsset(
    val sessionTokenHash12: String,
    val asset: AssetResponse,
    val cachedAtMs: Long
)
